import { getSkillLevel, isSkillUnlocked } from './skills'
import type { Survivor, WeaponFamily } from './types'

/** Per skill level: effective damage multiplier bonus (level 5 → +50%). */
export const WEAPON_SKILL_MULT_PER_LEVEL = 0.1

export function weaponDamageSkillMultiplier(
  survivor: Survivor,
  family: WeaponFamily,
): number {
  if (family === 'bow') {
    const lvl = getSkillLevel(survivor, 'archery')
    return 1 + lvl * WEAPON_SKILL_MULT_PER_LEVEL
  }
  const meleeLevel = isSkillUnlocked(survivor, 'melee')
    ? getSkillLevel(survivor, 'melee')
    : 0
  return 1 + meleeLevel * WEAPON_SKILL_MULT_PER_LEVEL
}

export function effectiveWeaponDamage(
  survivor: Survivor,
  baseDamage: number,
  family: WeaponFamily,
): number {
  const mult = weaponDamageSkillMultiplier(survivor, family)
  return Math.max(0, Math.round(baseDamage * mult))
}
